export const ActionTypes = {
  FETCH_PRODUCTS:'FETCH_PRODUCTS',
  SORT_PRODUCTS:'SORT_PRODUCTS',
  SET_PRODUCTS: "SET_PRODUCTS",
  ADD_PRODUCT: "ADD_PRODUCT",
  SELECTED_PRODUCT: "SELECTED_PRODUCT",
  ADD_TO_CART:"ADD_TO_CART",
  REMOVE_FROM_CART:"REMOVE_FROM_CART",
  REMOVE_SELECTED_PRODUCT: "REMOVE_SELECTED_PRODUCT",
  COUNT_DOWN:"COUNT_DOWN",
  COUNT_UP:"COUNT_UP"
};